// AuditTrailTypes.enum.ts
export enum AuditTrailType {
  ACCOUNTING_TRANSFER_CREATED = 'ACCOUNTING_TRANSFER_CREATED',
  AMENDMENT_CALCULATED = 'AMENDMENT_CALCULATED',
  AMENDMENT_CANCELLED = 'AMENDMENT_CANCELLED',
  AMENDMENT_POLICY_CREATED = 'AMENDMENT_POLICY_CREATED',
  AUTHORIZED_SIGNATORIES_DELETE = 'AUTHORIZED_SIGNATORIES_DELETE',
  AUTHORIZED_SIGNATORY_CREATED = 'AUTHORIZED_SIGNATORY_CREATED',
  AUTHORIZED_SIGNATORY_UPDATED = 'AUTHORIZED_SIGNATORY_UPDATED',
  AUXILIARY_CREATED = 'AUXILIARY_CREATED',
  AUXILIARY_UPDATED = 'AUXILIARY_UPDATED',
  BUSINESS_PARTNER_ACTIVATED = 'BUSINESS_PARTNER_ACTIVATED',
  BUSINESS_PARTNER_AND_PLANS_ASSIGNEDTO_USER = 'BUSINESS_PARTNER_AND_PLANS_ASSIGNEDTO_USER',
  BUSINESS_PARTNER_CREATED = 'BUSINESS_PARTNER_CREATED',
  BUSINESS_PARTNER_DEACTIVATED = 'BUSINESS_PARTNER_DEACTIVATED',
  BUSINESS_PARTNER_LINE_COMMISSION_UPDATED = 'BUSINESS_PARTNER_LINE_COMMISSION_UPDATED',
  BUSINESS_PARTNER_LINE_DEACTIVATED = 'BUSINESS_PARTNER_LINE_DEACTIVATED',
  BUSINESS_PARTNER_LINES_ACTIVATED = 'BUSINESS_PARTNER_LINES_ACTIVATED',
  BUSINESS_PARTNER_LINES_DEACTIVATED = 'BUSINESS_PARTNER_LINES_DEACTIVATED',
  BUSINESS_PARTNER_PLAN_COMMISSION_SET = 'BUSINESS_PARTNER_PLAN_COMMISSION_SET',
  BUSINESS_PARTNER_PLAN_DEACTIVATED = 'BUSINESS_PARTNER_PLAN_DEACTIVATED',
  BUSINESS_PARTNER_PLAN_DEACTIVATED_BY_SUBLINE = 'BUSINESS_PARTNER_PLAN_DEACTIVATED_BY_SUBLINE',
  BUSINESS_PARTNER_PLANS_ACTIVATED = 'BUSINESS_PARTNER_PLANS_ACTIVATED',
  BUSINESS_PARTNER_PLANS_ADDED = 'BUSINESS_PARTNER_PLANS_ADDED',
  BUSINESS_PARTNER_PLANS_DEACTIVATED = 'BUSINESS_PARTNER_PLANS_DEACTIVATED',
  BUSINESS_PARTNER_PV_CREATED = 'BUSINESS_PARTNER_PV_CREATED',
  BUSINESS_PARTNER_RV_CREATED = 'BUSINESS_PARTNER_RV_CREATED',
  BUSINESS_PARTNER_TOTAL_CREDIT_LIMIT_UPDATED = 'BUSINESS_PARTNER_TOTAL_CREDIT_LIMIT_UPDATED',
  BUSINESS_PARTNER_UPDATED = 'BUSINESS_PARTNER_UPDATED',
  BUSINESS_PARTNER_VIGNETTE_RANGE_ADDED = 'BUSINESS_PARTNER_VIGNETTE_RANGE_ADDED',
  BUSINESS_PARTNER_VIGNETTE_RANGE_UPDATED = 'BUSINESS_PARTNER_VIGNETTE_RANGE_UPDATED',
  CHANGE_POLICY_PAYMENT_INSTALLMENT = 'CHANGE_POLICY_PAYMENT_INSTALLMENT',
  CLAIM_COVER_CREATED = 'CLAIM_COVER_CREATED',
  CLAIM_COVER_UPDATED = 'CLAIM_COVER_UPDATED',
  CLAUSE_CREATED = 'CLAUSE_CREATED',
  CLAUSE_UPDATED = 'CLAUSE_UPDATED',
  COVER_CREATED = 'COVER_CREATED',
  COVER_UPDATED = 'COVER_UPDATED',
  DEACTIVATE_BUSINESS_PARTNER = 'DEACTIVATE_BUSINESS_PARTNER',
  DEACTIVATE_USER = 'DEACTIVATE_USER',
  DEACTIVATED_SUBLINE = 'DEACTIVATED_SUBLINE',
  FACULTATIVE_ACTIVATED = 'FACULTATIVE_ACTIVATED',
  FACULTATIVE_CLOSED = 'FACULTATIVE_CLOSED',
  FACULTATIVE_CREATED = 'FACULTATIVE_CREATED',
  FACULTATIVE_DOCUMENT_UPLOADED = 'FACULTATIVE_DOCUMENT_UPLOADED',
  FACULTATIVE_EXPIRED = 'FACULTATIVE_EXPIRED',
  FACULTATIVE_REINSURERS_UPDATED = 'FACULTATIVE_REINSURERS_UPDATED',
  FACULTATIVE_UPDATED = 'FACULTATIVE_UPDATED',
  LINE_ACTIVATED = 'LINE_ACTIVATED',
  LINE_ASSIGNEDTO_USER = 'LINE_ASSIGNEDTO_USER',
  LINE_DEACTIVATED = 'LINE_DEACTIVATED',
  LINE_GRACE_PERIOD_UPDATED = 'LINE_GRACE_PERIOD_UPDATED',
  MODIFY_BANKERS_BLANKET_BOND_DETAILS = 'MODIFY_BANKERS_BLANKET_BOND_DETAILS',
  MODIFY_EXPAT_DETAILS = 'MODIFY_EXPAT_DETAILS',
  MODIFY_MARINE_DETAILS = 'MODIFY_MARINE_DETAILS',
  MODIFY_MARINE_HULL_DETAILS = 'MODIFY_MARINE_HULL_DETAILS',
  MODIFY_MOTOR_DETAILS = 'MODIFY_MOTOR_DETAILS',
  MODIFY_POLICY_INSUREDS = 'MODIFY_POLICY_INSUREDS',
  MODIFY_POLICY_OWNER = 'MODIFY_POLICY_OWNER',
  MODIFY_POLICY_PAYER = 'MODIFY_POLICY_PAYER',
  MODIFY_POLICY_PERSONS = 'MODIFY_POLICY_PERSONS',
  MODIFY_PROPERTY_RISH_DESCRIPTION = 'MODIFY_PROPERTY_RISH_DESCRIPTION',
  MODIFY_RISK_DESCRIPTION = 'MODIFY_RISK_DESCRIPTION',
  PARTNER_CREATED = 'PARTNER_CREATED',
  PARTNER_UPDATED = 'PARTNER_UPDATED',
  PARTNERS_DELETE = 'PARTNERS_DELETE',
  PERSON_ACTIVATED = 'PERSON_ACTIVATED',
  PERSON_ADDRESS_ADDED = 'PERSON_ADDRESS_ADDED',
  PERSON_ADDRESS_UPDATED = 'PERSON_ADDRESS_UPDATED',
  PERSON_ADDRESSES_ACTIVATED = 'PERSON_ADDRESSES_ACTIVATED',
  PERSON_ADDRESSES_DEACTIVATED = 'PERSON_ADDRESSES_DEACTIVATED',
  PERSON_CREATED = 'PERSON_CREATED',
  PERSON_DEACTIVATED = 'PERSON_DEACTIVATED',
  PERSON_DETAILS_UPDATED = 'PERSON_DETAILS_UPDATED',
  PERSON_UPDATED = 'PERSON_UPDATED',
  PLAN_ACTIVATED = 'PLAN_ACTIVATED',
  PLAN_ADDITIONAL_FEES_AND_CHARGES_UPDATED = 'PLAN_ADDITIONAL_FEES_AND_CHARGES_UPDATED',
  PLAN_ALL_RISK_ADDED = 'PLAN_ALL_RISK_ADDED',
  PLAN_ALL_RISK_UPDATED = 'PLAN_ALL_RISK_UPDATED',
  PLAN_BUSINESS_PARTNER_PLAN_DEACTIVATED = 'PLAN_BUSINESS_PARTNER_PLAN_DEACTIVATED',
  PLAN_COVER_CREATED = 'PLAN_COVER_CREATED',
  PLAN_COVER_UPDATED = 'PLAN_COVER_UPDATED',
  PLAN_CREATED = 'PLAN_CREATED',
  PLAN_DEACTIVATED = 'PLAN_DEACTIVATED',
  PLAN_DEFAULT_COMMISSION_UPDATED = 'PLAN_DEFAULT_COMMISSION_UPDATED',
  PLAN_EXPAT_CREATED = 'PLAN_EXPAT_CREATED',
  PLAN_EXPAT_UPDATED = 'PLAN_EXPAT_UPDATED',
  PLAN_MEDICAL_ADDED = 'PLAN_MEDICAL_ADDED',
  PLAN_MEDICAL_UPDATED = 'PLAN_MEDICAL_UPDATED',
  PLAN_PLAN_DEACTIVATED = 'PLAN_PLAN_DEACTIVATED',
  PLAN_SUBLINE_DEACTIVATED = 'PLAN_SUBLINE_DEACTIVATED',
  PLAN_TRAVEL_CREATED = 'PLAN_TRAVEL_CREATED',
  PLAN_TRAVEL_UPDATED = 'PLAN_TRAVEL_UPDATED',
  PLAN_UPDATED = 'PLAN_UPDATED',
  PLAN_USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED = 'PLAN_USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED',
  POLICY_AMENDMENT_CREATED = 'POLICY_AMENDMENT_CREATED',
  POLICY_DOCUMENT_ADDED = 'POLICY_DOCUMENT_ADDED',
  POLICY_PROPOSAL_CORRECTION_INITIATED = 'POLICY_PROPOSAL_CORRECTION_INITIATED',
  PROPOSAL_CALCULATE_AND_SAVE = 'PROPOSAL_CALCULATE_AND_SAVE',
  PROPOSAL_CLOSE_PROPOSAL = 'PROPOSAL_CLOSE_PROPOSAL',
  PROPOSAL_COMMISSION_SPLIT = 'PROPOSAL_COMMISSION_SPLIT',
  PROPOSAL_CREATED = 'PROPOSAL_CREATED',
  PROPOSAL_ISSUE_POLICY = 'PROPOSAL_ISSUE_POLICY',
  PROPOSAL_PERSON_ADDRESS_CREATED = 'PROPOSAL_PERSON_ADDRESS_CREATED',
  PROPOSAL_PERSON_CREATED = 'PROPOSAL_PERSON_CREATED',
  PROPOSAL_POLICY_CORRECTION_INITIATED = 'PROPOSAL_POLICY_CORRECTION_INITIATED',
  PROPOSAL_SAVE_DRAFT = 'PROPOSAL_SAVE_DRAFT',
  PROVIDER_ACTIVATED = 'PROVIDER_ACTIVATED',
  PROVIDER_CREATED = 'PROVIDER_CREATED',
  PROVIDER_DEACTIVATED = 'PROVIDER_DEACTIVATED',
  PROVIDER_DEACTIVATED_BY_PERSON = 'PROVIDER_DEACTIVATED_BY_PERSON',
  PROVIDER_DELETED = 'PROVIDER_DELETED',
  PROVIDER_UPDATED = 'PROVIDER_UPDATED',
  REGENERATE_POLICY_DOCUMENTS = 'REGENERATE_POLICY_DOCUMENTS',
  SUBLINE_ACTIVATED = 'SUBLINE_ACTIVATED',
  SUBLINE_CREATED = 'SUBLINE_CREATED',
  SUBLINE_DEACTIVATED = 'SUBLINE_DEACTIVATED',
  SUBLINE_UPDATED = 'SUBLINE_UPDATED',
  SYSTEM_TRANSACTION_CREATED = 'SYSTEM_TRANSACTION_CREATED',
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  TRANSACTION_UPDATED = 'TRANSACTION_UPDATED',
  TREATY_ACTIVATED = 'TREATY_ACTIVATED',
  TREATY_CLOSED = 'TREATY_CLOSED',
  TREATY_CREATED = 'TREATY_CREATED',
  TREATY_DOCUMENT_UPLOADED = 'TREATY_DOCUMENT_UPLOADED',
  TREATY_EXPIRED = 'TREATY_EXPIRED',
  TREATY_REACTIVATED = 'TREATY_REACTIVATED',
  TREATY_REINSURERS_UPDATED = 'TREATY_REINSURERS_UPDATED',
  TREATY_UPDATED = 'TREATY_UPDATED',
  UPDATE_BUSINESS_PARTNER = 'UPDATE_BUSINESS_PARTNER',
  UPDATE_USER = 'UPDATE_USER',
  USER_ACTIVATED = 'USER_ACTIVATED',
  USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED = 'USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED',
  USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED_BY_SUBLINE = 'USER_ASSIGNED_BUSINESS_PARTNER_PLAN_DEACTIVATED_BY_SUBLINE',
  USER_ASSIGNED_LINE_ACTIVATED = 'USER_ASSIGNED_LINE_ACTIVATED',
  USER_ASSIGNED_LINE_DEACTIVATED = 'USER_ASSIGNED_LINE_DEACTIVATED',
  USER_ASSIGNED_LINE_WAS_DEACTIVATED = 'USER_ASSIGNED_LINE_WAS_DEACTIVATED',
  USER_ASSIGNED_PLAN_ACTIVATED = 'USER_ASSIGNED_PLAN_ACTIVATED',
  USER_ASSIGNED_PLAN_DEACTIVATED = 'USER_ASSIGNED_PLAN_DEACTIVATED',
  USER_AUTHORITY_DETAILS_UPDATED = 'USER_AUTHORITY_DETAILS_UPDATED',
  USER_CREATED = 'USER_CREATED',
  USER_DEACTIVATED = 'USER_DEACTIVATED',
  USER_UPDATED = 'USER_UPDATED',
}


